import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import {
  DaHelperAddPagesForm,
  DaHelperFeedbackForm,
  DaHelperRecordRegistrationResponse,
  DaHelperResponseRegistrationForm
} from './models';
import { HlAiExpensesInAttachments } from '@state';

export type RegisterDaHelperResponseTrigger = ReturnType<
  typeof useRegisterDaHelperResponseMutation
>[0];

export const expenseEvaluationDaHelperApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'hl-ai-da-helper-api',
  endpoints: (build) => ({
    registerDaHelperResponse: build.mutation<
      DaHelperRecordRegistrationResponse,
      DaHelperResponseRegistrationForm
    >({
      query: (data) => ({
        url: `/secured/da-helper/register-response`,
        method: 'POST',
        data
      })
    }),
    rateDaHelperAttachmentResponse: build.mutation<void, DaHelperFeedbackForm>({
      query: (data) => ({
        url: `/secured/da-helper/feedback`,
        method: 'POST',
        data
      })
    }),
    removeDaHelperAttachmentPage: build.mutation<
      void,
      { historyRecordId: number; pageNumber: number }
    >({
      query: ({ historyRecordId, pageNumber }) => ({
        url: `/secured/da-helper/history-record-id/${historyRecordId}/page/${pageNumber}/delete`,
        method: 'DELETE'
      })
    }),
    addDaHelperAttachmentPages: build.mutation<
      void,
      { historyRecordId: number; data: DaHelperAddPagesForm }
    >({
      query: ({ historyRecordId, data }) => ({
        url: `/secured/da-helper/history-record-id/${historyRecordId}/add-pages`,
        method: 'POST',
        data
      })
    }),
    resetToOriginalDaHelperPages: build.mutation<
      void,
      { historyRecordId: number }
    >({
      query: ({ historyRecordId }) => ({
        url: `/secured/da-helper/history-record-id/${historyRecordId}/reset-original-pages`,
        method: 'PATCH'
      })
    }),
    getCachedDaHelperResponse: build.query<
      HlAiExpensesInAttachments,
      { evaluationId: number }
    >({
      query: ({ evaluationId }) => ({
        url: `/secured/da-helper/evaluation/${evaluationId}/get-cache`,
        method: 'GET'
      })
    })
  })
});

export const {
  useAddDaHelperAttachmentPagesMutation,
  useLazyGetCachedDaHelperResponseQuery,
  useRateDaHelperAttachmentResponseMutation,
  useRegisterDaHelperResponseMutation,
  useRemoveDaHelperAttachmentPageMutation,
  useResetToOriginalDaHelperPagesMutation
} = expenseEvaluationDaHelperApi;
